<template>
  <div>
    <div
      :class="state.showTooltip ? 'koc-progress-bar-tooltip-active' : 'koc-progress-bar-tooltip'"
    >
      <span>{{ `${state.lessonsCompleted} of ${state.allLessons.length} Lessons Completed` }}</span>
    </div>
    <div v-if="expandedView">
      <div class="koc-progress-bar-course-page">
        <div
          class="koc-progress-bar-course-page-percentage"
          :style="`width: ${state.percentage}%;`"
        >
          <span class="koc-progress-bar-course-page-percentage-text koc-montserrat">{{ `Completed ${state.lessonsCompleted} of ${state.allLessons.length} Lessons` }}</span>
        </div>  
      </div>
      <div class="koc-progress-bar-course-page-spacing" />
    </div>
    <div v-else>
      <div  
        class="koc-progress-bar"
        @mouseover="state.showTooltip = true"
        @mouseleave="state.showTooltip = false"
      >
        <div
          class="koc-progress-bar-percentage"
          :style="`width: ${state.percentage}%;`"
        />          
      </div>
      <div class="koc-progress-bar-spacing" />
    </div>
  </div>
</template>

<script src="./progress-bar.js"></script>
<style lang="scss" scoped src="./progress-bar.scss"></style>